import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { BusinessCard } from "../components/BusinessCard";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Search } from "lucide-react";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const cat = params.get("category") || "";
  const [query, setQuery] = useState(q);
  const [category, setCategory] = useState(cat);
  const [categories, setCategories] = useState([]);
  const [results, setResults] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);

  const load = async () => {
    const { data } = await api.get("/businesses", { params: { q: q || undefined, category: cat || undefined, limit: 36 } });
    setResults(data.items);
    setTotal(data.total);
  };
  useEffect(() => { load(); }, [q, cat]);

  const submit = (e) => {
    e.preventDefault();
    const next = {};
    if (query) next.q = query;
    if (category) next.category = category;
    setParams(next);
  };

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8 py-12" data-testid="search-page">
      <div className="mb-8">
        <div className="text-xs font-mono-tag uppercase tracking-[0.2em] text-zinc-400 mb-2">/ Explore</div>
        <h1 className="font-display text-5xl tracking-tight">Search the directory</h1>
      </div>

      <form onSubmit={submit} className="flex flex-col md:flex-row gap-3 mb-10">
        <div className="flex-1 flex items-center gap-2 rounded-lg border border-zinc-300 bg-white p-1.5">
          <Search className="h-4 w-4 ml-3 text-zinc-400" />
          <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search by name, service, or keyword"
                 className="border-0 focus-visible:ring-0 focus-visible:ring-offset-0" data-testid="search-input" />
        </div>
        <Select value={category || "all"} onValueChange={(v) => setCategory(v === "all" ? "" : v)}>
          <SelectTrigger className="md:w-64" data-testid="search-cat-trigger"><SelectValue placeholder="All categories" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All categories</SelectItem>
            {categories.map((c) => <SelectItem key={c.slug} value={c.slug}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Button type="submit" className="btn-brand" data-testid="search-submit">Search</Button>
      </form>

      <div className="text-sm text-zinc-500 mb-4 font-mono-tag uppercase tracking-wider">{total} result{total === 1 ? "" : "s"}</div>

      {results.length === 0 ? (
        <div className="text-center py-24 border border-dashed rounded-xl text-zinc-500">No matches. Try a broader keyword.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {results.map((b, i) => <BusinessCard b={b} idx={i} key={b.id} />)}
        </div>
      )}
    </div>
  );
}
